import { render, staticRenderFns } from "./ServerGroupForm.vue?vue&type=template&id=0765d558&scoped=true"
import script from "./ServerGroupForm.vue?vue&type=script&lang=js"
export * from "./ServerGroupForm.vue?vue&type=script&lang=js"
import style0 from "./ServerGroupForm.vue?vue&type=style&index=0&id=0765d558&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0765d558",
  null
  
)

export default component.exports